import { jsx as _jsx } from "react/jsx-runtime";
import { colors } from "./tokens.js";
const toneStyles = {
    neutral: { background: colors.neutralChipBg, color: colors.muted },
    blue: { background: colors.accentBlueBg, color: colors.accentBlue },
    green: { background: colors.supportGreenBg, color: colors.supportGreen },
    amber: { background: "#faf3e2", color: colors.warnAmber },
    red: { background: colors.dangerRedBg, color: colors.dangerRed },
};
export function Chip({ tone = "neutral", children }) {
    return (_jsx("span", { style: {
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            fontSize: 12,
            fontWeight: 600,
            borderRadius: 999,
            padding: "4px 12px",
            ...toneStyles[tone],
        }, children: children }));
}
